// Ported from weco-dashboard/src/components/Items/LiveData/utils.js -- mirrors
// denshi's app::kBrake* firmware bitmask, reported per odrive message as
// brake_flags. SATURATED means the drive latched a duty demand it could not
// deliver at some point, not that it is saturated right this instant.
export const ODriveBrakeFlag = {
  ARMED: 1 << 0,
  SATURATED: 1 << 1,
};

export function hasFlag(flags, flag) {
  return typeof flags === 'number' && (flags & flag) === flag;
}

// Ported from the same utils.js. Index = the numeric axis_state on the wire.
// Index 5 has no enumerator in the ODrive firmware, hence the hole.
const ODRIVE_AXIS_STATE = [
  'UNDEFINED',
  'IDLE',
  'STARTUP_SEQUENCE',
  'FULL_CALIBRATION_SEQUENCE',
  'MOTOR_CALIBRATION',
  undefined,
  'ENCODER_INDEX_SEARCH',
  'ENCODER_OFFSET_CALIBRATION',
  'CLOSED_LOOP_CONTROL',
  'LOCKIN_SPIN',
  'ENCODER_DIR_FIND',
  'HOMING',
  'ENCODER_HALL_POLARITY_CALIBRATION',
  'ENCODER_HALL_PHASE_CALIBRATION',
];

// Falls back to the raw number so an unrecognised state is still visible
// rather than silently blanked.
export function formatAxisState(value) {
  if (value == null) return null;
  return ODRIVE_AXIS_STATE[value] ?? String(value);
}
